import { motion } from "framer-motion";
import Logo from "./Logo";

const Header = ({ onOrder }) => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 left-0 right-0 z-50 bg-[#F9F6F0]/80 backdrop-blur-xl border-b border-[#D3D7CF]/60"
    data-testid="site-header"
  >
    <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
      <a href="#top" className="flex items-center gap-3" data-testid="header-logo-link">
        <Logo size={38} />
        <span className="font-heading font-semibold text-xl text-[#2C402B] tracking-tight">
          Crochet Els
        </span>
      </a>
      <nav className="hidden sm:flex items-center gap-8 text-sm font-semibold text-[#576956]" data-testid="header-nav">
        <a href="#shop" className="hover:text-[#2C402B] transition-colors" data-testid="nav-shop-link">Shop</a>
        <a href="#inspiration" className="hover:text-[#2C402B] transition-colors" data-testid="nav-inspiration-link">Inspiration</a>
      </nav>
      <button
        onClick={onOrder}
        data-testid="header-order-button"
        className="rounded-full bg-[#2C402B] text-[#F9F6F0] px-5 py-2.5 text-sm font-heading font-medium transition-[transform,background-color,box-shadow] duration-300 hover:bg-[#435E42] hover:scale-105 hover:shadow-[0_10px_25px_rgba(44,64,43,0.25)]"
      >
        Order Yours
      </button>
    </div>
  </motion.header>
);

export default Header;
